/* ── Team Members ───────────────────────────────────────────────────────── */
function TeamMembersPage({showToast}){
  const [members,setMembers]=React.useState([
    {id:1,name:'Admin User',email:'admin@taxlab.ae',role:'admin',status:'active',lastActive:'2 min ago',avatar:'A'},
    {id:2,name:'Sarah Chen',email:'sarah@albatha.com',role:'operator',status:'active',lastActive:'1 hour ago',avatar:'SC'},
    {id:3,name:'Raj Patel',email:'raj@albatha.com',role:'developer',status:'active',lastActive:'3 hours ago',avatar:'RP'},
    {id:4,name:'Aisha Al-Mansoori',email:'aisha@taxlab.ae',role:'viewer',status:'active',lastActive:'1 day ago',avatar:'AA'},
  ]);
  const [showInvite,setShowInvite]=React.useState(false);
  const [editingId,setEditingId]=React.useState(null);
  const [editForm,setEditForm]=React.useState({});

  const updateRole=(id,role)=>{
    setMembers(prev=>prev.map(m=>m.id===id?{...m,role}:m));
    showToast&&showToast('Role updated');
    setEditingId(null);
  };
  const removeMember=id=>{
    if(!confirm('Remove this team member?'))return;
    setMembers(prev=>prev.filter(m=>m.id!==id));
    showToast&&showToast('Member removed');
  };

  const roleColor=r=>({admin:'var(--error)',operator:'var(--warning)',developer:'var(--brand-start)',viewer:'var(--text3)'})[r]||'var(--text3)';

  return(
    <div className="page">
      <div className="page-header">
        <h2 className="page-title">Team Members</h2>
        <div className="page-actions">
          <button className="btn btn-primary" onClick={()=>setShowInvite(true)}>+ Invite Member</button>
        </div>
      </div>
      <div style={{color:'var(--text2)',fontSize:13,marginBottom:14,maxWidth:780}}>
        Manage who can access this platform. Each member is assigned a role that controls
        their permissions. Admins have full access; viewers are read-only.
      </div>
      <div className="card" style={{padding:0,overflow:'hidden'}}>
        <table style={{width:'100%',fontSize:13,borderCollapse:'collapse'}}>
          <thead>
            <tr style={{borderBottom:'1px solid var(--border)',color:'var(--text3)',textAlign:'left',fontSize:11,textTransform:'uppercase',letterSpacing:'.5px'}}>
              <th style={{padding:'10px 12px'}}>Member</th>
              <th style={{padding:'10px 12px'}}>Email</th>
              <th style={{padding:'10px 12px'}}>Role</th>
              <th style={{padding:'10px 12px'}}>Status</th>
              <th style={{padding:'10px 12px'}}>Last Active</th>
              <th style={{padding:'10px 12px',textAlign:'right'}}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {members.map(m=>(
              <tr key={m.id} style={{borderBottom:'1px solid var(--border)'}}>
                <td style={{padding:'10px 12px'}}>
                  <div style={{display:'flex',alignItems:'center',gap:8}}>
                    <div style={{width:30,height:30,borderRadius:'50%',background:'var(--brand-start)',color:'#fff',display:'flex',alignItems:'center',justifyContent:'center',fontSize:11,fontWeight:600,flexShrink:0}}>
                      {m.avatar}
                    </div>
                    <span style={{fontWeight:500}}>{m.name}</span>
                  </div>
                </td>
                <td style={{padding:'10px 12px',color:'var(--text2)',fontSize:12}}>{m.email}</td>
                <td style={{padding:'10px 12px'}}>
                  {editingId===m.id?(
                    <select className="input" style={{padding:'4px 8px',fontSize:12}} value={editForm.role} onChange={e=>setEditForm({...editForm,role:e.target.value})} onBlur={()=>updateRole(m.id,editForm.role)} autoFocus>
                      <option value="admin">Admin</option>
                      <option value="operator">Operator</option>
                      <option value="developer">Developer</option>
                      <option value="viewer">Viewer</option>
                    </select>
                  ):(
                    <button onClick={()=>{setEditingId(m.id);setEditForm({role:m.role})}} style={{background:'none',border:'none',color:roleColor(m.role),fontWeight:500,cursor:'pointer',fontSize:12,textTransform:'capitalize',padding:0}}>
                      {m.role}
                    </button>
                  )}
                </td>
                <td style={{padding:'10px 12px'}}>
                  <span className={`badge badge-${m.status==='active'?'success':'warning'}`}>{m.status}</span>
                </td>
                <td style={{padding:'10px 12px',color:'var(--text2)',fontSize:12}}>{m.lastActive}</td>
                <td style={{padding:'10px 12px',textAlign:'right'}}>
                  <button className="btn btn-ghost" style={{fontSize:11,padding:'3px 8px'}} onClick={()=>setEditingId(m.id)}>Change role</button>
                  <button className="btn btn-danger-ghost" style={{fontSize:11,padding:'3px 8px',marginLeft:4}} onClick={()=>removeMember(m.id)}>Remove</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {showInvite&&<InviteDialog showToast={showToast} onClose={()=>setShowInvite(false)} onInvite={email=>{setMembers(prev=>[...prev,{id:Date.now(),name:email.split('@')[0],email,role:'viewer',status:'pending',lastActive:'Never',avatar:email.slice(0,2).toUpperCase()}]);setShowInvite(false);showToast&&showToast('Invitation sent to '+email)}}/>}
    </div>
  );
}
